import { LogOut } from "lucide-react";
import { logout, getUser, roleDisplayLabel } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { ProjectSwitcher } from "@/components/ProjectSwitcher";

export const AppHeader = ({ title, subtitle, right }) => {
  const u = getUser();
  return (
    <header className="header-dark sticky top-0 z-40 border-b border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-10 w-10 shrink-0 overflow-hidden">
            <img src="/logo.png" alt="Coke @9" className="h-full w-full object-contain" />
          </div>
          <div className="min-w-0">
            <div className="font-display font-extrabold text-sm sm:text-base text-white truncate" data-testid="app-title">
              {title || "Coke @9"}
            </div>
            {subtitle && (
              <div className="text-[11px] text-neutral-400 truncate">{subtitle}</div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <ProjectSwitcher />
          {right}
          {u && (
            <div className="hidden sm:flex flex-col items-end mr-2">
              <div className="text-xs text-neutral-300" data-testid="header-user-name">{u.name}</div>
              {/* Per COO — the "Client" chip is hidden on the client-facing header so it reads as a shared operations view, not a role-scoped one. */}
              {u.role !== "Client" && (
                <div className="text-[10px] uppercase tracking-widest text-neutral-500" data-testid="header-role-chip">{roleDisplayLabel(u.role)}</div>
              )}
            </div>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={logout}
            data-testid="logout-btn"
            className="text-neutral-300 hover:text-white hover:bg-neutral-800"
          >
            <LogOut className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">Logout</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
